import axios from "axios";

const api = axios.create({
  baseURL: "https://portalapi.cozimax.com.br/",
  //baseURL: "http://10.0.2.152:3205",
  auth :{username:'cozimax2023',password:'cozimax2023'}
});

function emitApiStatus(online) {
  window.dispatchEvent(new CustomEvent("api-status", { detail: { online } }));
}

api.interceptors.response.use(
  (response) => {
    emitApiStatus(true);
    return response;
  },
  (error) => {
    if (!error.response) {
      emitApiStatus(false);
      return Promise.reject(new Error("Não foi possível conectar ao servidor. Verifique sua conexão ou tente novamente mais tarde."));
    }

    emitApiStatus(true); // servidor respondeu (mesmo com erro) = está no ar

    const status = error.response.status;

    if (status === 401 || status === 403) {
      return Promise.reject(new Error("Acesso não autorizado. Faça login novamente."));
    }

    if (status >= 500) {
      return Promise.reject(new Error("Erro interno no servidor. Tente novamente em instantes."));
    }

    return Promise.reject(new Error(error.response.data?.message || "Ocorreu um erro inesperado."));
  }
);

export function getImagemComunicadoUrl(codcom) {
  if (!codcom) return null;
  // baseURL tem barra final ("https://.../") - sem remover, essa concatenação manual (fora do
  // axios, que normaliza barra duplicada sozinho) gera "..com.br//api/comunicado/imagem/..",
  // que pode bater em outro lugar do servidor em vez da rota certa (foi o que causava a imagem
  // "formato inválido" no browser mesmo com 200 OK).
  const base = api.defaults.baseURL.replace(/\/+$/, '')
  return `${base}/api/comunicado/imagem/${codcom}`;
}

// O backend salva o HTML do conteúdo do comunicado com src RELATIVO (/api/comunicado/imagem/...)
// pras imagens embutidas pelo editor rico (ver ProcessarImagensConteudoComunicado no srvPortal) -
// precisa virar URL absoluta aqui antes de renderizar, mesmo motivo/mesma barra dupla do
// getImagemComunicadoUrl acima.
export function resolverImagensConteudoComunicado(html) {
  if (!html) return html;
  const base = api.defaults.baseURL.replace(/\/+$/, '')
  return html.replaceAll('src="/api/comunicado/imagem/', `src="${base}/api/comunicado/imagem/`);
}

// Mesmo motivo/mesma barra dupla do getImagemComunicadoUrl acima - imagem de
// item de menu tipo 'conteudo' (ver GetImagemMenuItem/uServiceEndo.pas).
export function getImagemMenuItemUrl(codite) {
  if (!codite) return null
  const base = api.defaults.baseURL.replace(/\/+$/, '')
  return `${base}/api/menu-item/imagem/${codite}`
}

// Hotspots (botões clicáveis desenhados na imagem de um item 'conteudo') e
// detalhe de um item avulso - usados pela tela MenuConteudo pra montar as
// áreas clicáveis e resolver o alvo de um hotspot tipo 'conteudo' (outra
// imagem/página) na hora do clique (ver HotspotEditor no CozimaxERP,
// pedido do usuário, 2026-09-02).
export async function getMenuItemHotspots(codite) {
  if (!codite) return []
  const res = await api.get(`/portal/menu-item/hotspots/${codite}`)
  return Array.isArray(res.data) ? res.data : []
}

export async function getMenuItemDetalhe(codite) {
  if (!codite) return null
  const res = await api.get(`/portal/menu-item/${codite}`)
  return res.data || null
}

export default api;


//Public Key:
//BB3MFMgYKO4JglRlKiC8sbnFG3m7Fb0DhoOB-mIAOdCLGIKhBbVk1JgBSlA90DTVofOh5MgKyfxmeDMwhDMISHc

//Private Key:
//a4aJzCqIOZbTUT3Dr77GxHh3HJa3HjgE9bNxrbvVcVE